import { Controller } from "stimulus";
import hideElement from "../functions/hideElement";
import showElement from "../functions/showElement";

export default class extends Controller {
  static targets = ["element1", "element2"];

  static values = { 
    once: { type: Boolean, default: false }, 
    hasToggled: { type: Boolean, default: false }
  };


  connect() {
    if (this.showElement2) {
      this.element1Display = hideElement(this.element1Target);
    } else {
      this.element2Display = hideElement(this.element2Target);
    }
  }

  onToggle() {
    if (!this.canToggle) return;


    if (this.element1Visible) {
      this.element1Display = hideElement(this.element1Target);
      showElement(this.element2Target, this.element2Display);
    } else {
      showElement(this.element1Target, this.element1Display);
      this.element2Display = hideElement(this.element2Target);
    }

    this.hasToggledValue = true;
  }

  get showElement2() {
    return this.element.dataset.showElement2 === "true";
  }

  get element1Visible() {
    return this.element1Target.style.display !== "none";
  }

  get canToggle() {
    return !(this.onceValue && this.hasToggledValue);
  }
}
